import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { FlexRow, FlexRowDiv } from "./common.styles";
import { SemiBoldLittleText } from "./HXMobilePage.styles";
import PhoneForwarded from "@mui/icons-material/PhoneForwarded";
import RefreshIcon from "@mui/icons-material/Refresh";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import ErrorOutline from "@mui/icons-material/ErrorOutline";
import React from "react";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import WarningAmber from "@mui/icons-material/WarningAmber";
export const OTPContainer = styled(FlexRowDiv) `
    justify-content: center;
    gap: 8px;
    align-self: center;
`;
export const OTPSlot = styled.div `
    width: 44px;
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${fontSizes.SUPER};
    font-weight: ${fontWeights.NORMAL};

    &:nth-child(3) {
        margin-right: 12px;
    }

    border-radius: 12px;
    border: 1px solid ${colors.blue_30};
    border-color: ${(p) => (p.$active ? colors.blue_50 : colors.blue_30)};
    outline-offset: -1px;
    outline: ${(p) => (p.$active ? `2px solid ${colors.blue_50}` : "none")};
    outline-color: ${(p) => (p.$active ? colors.blue_50 : colors.blue_30)};

    ${(props) => (props.$isPopulated || props.$isFocused) &&
    css `
            border-color: ${colors.blue_50};
            outline-color: ${colors.blue_50};
        `}

    ${(props) => props.$isError &&
    !props.$isPopulated &&
    css `
            border-color: ${colors.tulip_main};
            outline-color: ${colors.tulip_main};
        `}

    ${(props) => props.$isError &&
    props.$isPopulated &&
    css `
            border-color: ${colors.tulip_dark};
            outline-color: ${colors.tulip_dark};
        `}
`;
export const OTPStatusRow = styled(FlexRow) `
    justify-content: center;
    align-items: center;
    gap: 8px;
    min-height: 24px;
    margin-top: 10px;
`;
export const VerifyOTPSpinner = styled(CircularProgress).attrs({ size: 16 }) `
    color: ${colors.black_lighter};
`;
export const VerifyOTPStatusText = styled.span `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
    ${(props) => props.$isError &&
    !props.$isPopulated &&
    css `
            color: ${colors.tulip_main};
        `}

    ${(props) => props.$isError &&
    props.$isPopulated &&
    css `
            color: ${colors.tulip_dark};
        `}
`;
export const VerificationActionRow = styled(FlexRow) `
    align-self: stretch;
    align-items: center;
    gap: 16px;
    padding: 16px 12px;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
export const VerifyOTPButtonSubtext = styled(SemiBoldLittleText) `
    color: ${colors.navy_main};
    ${(props) => props.$disabled &&
    css `
            color: ${colors.navy_50};
        `}
`;
const OTPBaseIconButton = css `
    width: 36px;
    height: 36px;
    border-radius: 999px;
    padding: 8px;
    background-color: ${colors.blue_10};
    pointer-events: none;
`;
export const VerifyOTPRefreshIcon = styled(IconButton).attrs({
    children: React.createElement(RefreshIcon),
}) `
    ${OTPBaseIconButton}
`;
export const VerifyOTPTryDifferentPhoneIcon = styled(IconButton).attrs({
    children: React.createElement(PhoneForwarded),
}) `
    ${OTPBaseIconButton}
`;
export const VerifyOTPClearIcon = styled(IconButton) `
    ${OTPBaseIconButton}
`;
export const VerifyOTPCodeSentRow = styled(FlexRow) `
    align-self: stretch;
    align-items: center;
    gap: 16px;
    padding: 16px 12px;
`;
export const VerifyOTPCodeSentCheckWrapper = styled.div `
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.forest_8};
    border-radius: 999px;
`;
export const VerifyOTPCodeSentCheckIcon = styled(CheckCircleOutline) `
    width: 20px;
    height: 20px;
    color: ${colors.forest_main};
`;
export const VerifyOTPCodeSentText = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.forest_main};
    line-height: normal;
    text-align: left;
`;
export const VerifyOTPErrorRow = styled(FlexRow) `
    align-self: stretch;
    align-items: center;
    gap: 16px;
    padding: 16px 12px;
`;
export const VerifyOTPErrorIconWrapper = styled.div `
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.tulip_8};
    border-radius: 999px;
`;
export const VerifyOTPErrorIcon = styled(ErrorOutline) `
    width: 20px;
    height: 20px;
    color: ${colors.tulip_main};
`;
export const VerifyOTPErrorText = styled.div `
    font-size: ${fontSizes.LITTLE};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.tulip_main};
    line-height: normal;
    text-align: left;
`;
export const VerifyOTPLockoutIconWrapper = styled.div `
    width: 88px;
    height: 88px;
    min-width: 88px;
    min-height: 88px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.accents_sunset_12};
    border-radius: 999px;
`;
export const VerifyOTPLockoutWarningIcon = styled(WarningAmber) `
    width: 40px;
    height: 40px;
    color: ${colors.sunset_main};
`;
export const VerifyOTPFakeCaret = styled.div `
    width: 1px;
    height: 50%;
    background-color: ${(props) => (props.$isError ? colors.tulip_main : colors.blue_50)};
    animation: blink 1.2s ease-out infinite;

    @keyframes blink {
        0%,
        70%,
        100% {
            opacity: 1;
        }
        20%,
        50% {
            opacity: 0;
        }
    }
`;
